import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { "data-testid": "profile-creation-details-experience-level-block" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import {ref, onBeforeMount, computed} from 'vue';
    import {useStore} from 'vuex';
    import {useRouter} from 'vue-router';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import {ExperienceLevel, ProfileCreationForm} from '@/profile-creation-wizard/types';
    import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';

    type ExperienceLevelContent = {
        label: string;
        description: string;
    };

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategorizationLevelSelection',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const creationForm = ref<ProfileCreationForm>(store.getters[getters.creationForm]);

    const experienceLevels = ref(Object.values(ExperienceLevel));
    const options = ref(buildLevelsOptions());
    const selectedExperienceLevel = ref([]);
    const isStrategy = ref(false);

    onBeforeMount(() => {
        selectedExperienceLevel.value = [creationForm.value.experienceLevel];
        isStrategy.value = router.currentRoute.value.meta.funnelMode === ProfileCreationFunnelMode.STRATEGY;
    });

    const jobTitle = computed(() => creationForm.value.headline);

    function selectExperienceLevel(level: ExperienceLevel): void {
        // We can actually unselect the radio when using VJoySelectableItemGroup, in this case the custom event returns nothing
        if (level) {
            store.commit(mutations.selectExperienceLevel, level);
        } else {
            store.commit(mutations.unselectExperienceLevel);
        }
    }

    function buildLevelsOptions() {
        return experienceLevels.value.map((level: ExperienceLevel) => {
            return {
                value: level,
                id: experienceLevelId(level),
                label: getExperienceLevelContent(level).label,
                subLabel: getExperienceLevelContent(level).description,
            };
        });
    }

    function experienceLevelId(experienceLevel: ExperienceLevel): string {
        return `profile-creation-details-experience-level-${experienceLevel.toLowerCase()}`;
    }

    function getExperienceLevelContent(experienceLevel: ExperienceLevel): ExperienceLevelContent {
        return {
            label: msg(`profile.creation.completion.wizard.categorization.experienceLevel.label.v2.${experienceLevel}`),
            description: msg(`profile.creation.completion.wizard.categorization.experienceLevel.description.v2.${experienceLevel}`),
        };
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoySelectableItemGroup = _resolveComponent("VJoySelectableItemGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.details.experience.title')), 1),
    (isStrategy.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "profile-creation-details-experience-level__title",
          innerHTML: _ctx.$icu('profile.creation.wizard.strategy.categorization.experience.level.subtitle')
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "profile-creation-details-experience-level__title",
          innerHTML: _ctx.$icu('profile.creation.completion.wizard.details.job.subtitle', {jobTitle: jobTitle.value})
        }, null, 8, _hoisted_3)),
    _createVNode(_component_VJoySelectableItemGroup, {
      value: selectedExperienceLevel.value,
      "onUpdate:value": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedExperienceLevel).value = $event)),
        selectExperienceLevel
      ],
      "full-width": true,
      options: options.value
    }, null, 8, ["value", "options"])
  ]))
}
}

})